import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { key: 5 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 6 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 7,
  class: "geolocation-text"
}
const _hoisted_11 = {
  key: 8,
  class: "geolocation-coords"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("span", {
    id: `geolocation-wrapper+${_ctx.id}`,
    class: "geolocation"
  }, [
    (_ctx.showPermissions)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, "Geolocation " + _toDisplayString(_ctx.permissions), 1))
      : _createCommentVNode("", true),
    (_ctx.showPermissions)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, "location " + _toDisplayString(_ctx.geolocation), 1))
      : _createCommentVNode("", true),
    (_ctx.showPermissions)
      ? (_openBlock(), _createElementBlock("span", _hoisted_4, "counter " + _toDisplayString(_ctx.counter), 1))
      : _createCommentVNode("", true),
    (_ctx.showPermissions)
      ? (_openBlock(), _createElementBlock("p", {
          key: 3,
          innerHTML: _ctx.msg
        }, null, 8, _hoisted_5))
      : _createCommentVNode("", true),
    (!_ctx.hideButton)
      ? (_openBlock(), _createBlock(_component_v_btn, {
          key: 4,
          class: "geolocation-button",
          density: _ctx.density,
          size: _ctx.size,
          variant: _ctx.geolocation ? (_ctx.useTextButton ? 'tonal' : 'flat') : 'outlined',
          elevation: _ctx.elevation,
          loading: _ctx.loading,
          icon: _ctx.useTextButton ? undefined : _ctx.icon,
          "prepend-icon": _ctx.useTextButton ? _ctx.icon : undefined,
          color: _ctx.geolocationError ? 'red' : _ctx.color,
          onClick: _ctx.getLocation,
          text: _ctx.useTextButton ? _ctx.label : undefined
        }, null, 8, ["density", "size", "variant", "elevation", "loading", "icon", "prepend-icon", "color", "onClick", "text"]))
      : _createCommentVNode("", true),
    ((_ctx.showTextProgress || _ctx.showProgressCircle) && _ctx.loading && _ctx.hideButton && _ctx.permissionGranted)
      ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
          (_ctx.showProgressCircle)
            ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                key: 0,
                size: _ctx.progressCircleSize,
                width: 2,
                color: _ctx.color,
                indeterminate: ""
              }, null, 8, ["size", "color"]))
            : _createCommentVNode("", true),
          (_ctx.showTextProgress)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Fetching location"))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    ((_ctx.showTextProgress ) && _ctx.loaded)
      ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
          (_ctx.showTextProgress)
            ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                _createVNode(_component_v_icon, {
                  size: "small",
                  icon: "mdi-check-circle-outline"
                }),
                _cache[0] || (_cache[0] = _createTextVNode(" Using your location", -1))
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.showTextLabel && !_ctx.useTextButton)
      ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
          _renderSlot(_ctx.$slots, "default", {}, () => [
            _createTextVNode(_toDisplayString(_ctx.label), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showCoords)
      ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
          _createElementVNode("p", null, "Latitude: " + _toDisplayString(_ctx.geolocation?.latitude), 1),
          _createElementVNode("p", null, "Longitude: " + _toDisplayString(_ctx.geolocation?.longitude), 1)
        ]))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}